<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">科室</div>
            <el-select v-model="add_DepartmentId" placeholder="请选择科室" style="width: 100%">
              <el-option
                  v-for="item in departmentList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">收支项目名称</div>
            <el-input v-model="add_Name" placeholder="请输入收支项目名称"></el-input>
          </el-col>
        </el-row>

        <el-row class="row">

          <el-col :span="12" class="item">
            <div class="label">收支类型</div>
            <el-select v-model="add_Type" placeholder="请选择收支类型" style="width: 100%;">
              <el-option
                  v-for="item in type_arr"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-col>

<!--          <el-col :span="12" class="item">-->
<!--            <div class="label">排序</div>-->
<!--            <el-input v-model="add_Sort" placeholder="请输入排序"></el-input>-->
<!--          </el-col>-->

        </el-row>

      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Add',
  props: [],
  data() {
    return {

      loading: false,

      add_Name:'',
      add_Sort:0,
      add_DepartmentId:'',
      add_Type:'',

      departmentList:[],
      type_arr:[{value:'in',label:'收入'},{value:'out',label:'支出'}],


    }
  },
  methods: {
    init(){

      this.add_Name = '';
      this.add_Sort = 0;
      this.add_DepartmentId = '';
      this.add_Type = '';

      this.getDepartmentList();

    },
    closeSelf() {
      this.$emit("closeAdd");
    },


    getDepartmentList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Department/AdmList',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.departmentList = response.data.data.list;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    confirm(){

      if(this.add_Name === ''){
        this.$message("输入收入项目名称");
        return;
      }
      if(this.add_Sort === ''){
        this.$message("输入排序");
        return;
      }

      if(this.add_DepartmentId === ''){
        this.$message("选择科室");
        return;
      }
      if(this.add_Type === ''){
        this.$message("选择收支类型");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'DepartmentInOut/AdmAdd',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name: this.add_Name,
          departmentId:this.add_DepartmentId,
          type:this.add_Type,
          sort:this.add_Sort,
        }

      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>

